import type { ConceptDef } from '../types';

export const tactThingsInTheHouse: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-things-in-the-house',
  label: 'Expressive Things in the House',
  category: 'Expressive',
  description: 'Show something from home; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🛏 bed' },
      { prompt: '🪑 chair' },
      { prompt: '🛋 sofa' },
      { prompt: '🚪 door' },
      { prompt: '🪟 window' },
      { prompt: '🛁 bath' },
      { prompt: '🚽 toilet' },
      { prompt: '📺 television' },
    ],
  },
};
